import { render } from "./MemberLeftNav.vue?vue&type=template&id=4c842c8e&scoped=true"
import script from "./MemberLeftNav.vue?vue&type=script&lang=js"
export * from "./MemberLeftNav.vue?vue&type=script&lang=js"

import "./MemberLeftNav.vue?vue&type=style&index=0&id=4c842c8e&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c842c8e"]])

export default __exports__